"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classnames = _interopRequireDefault(require("classnames"));

var _icon = require("../../utils/icon");

var _convertUnsafeMethod = _interopRequireDefault(require("../../utils/convertUnsafeMethod"));

var _createId = _interopRequireDefault(require("../../utils/createId"));

var _filterDOMProps = _interopRequireDefault(require("../../utils/filterDOMProps"));

var _focusRing = _interopRequireDefault(require("../../utils/focusRing"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _class, _class2, _temp;

var Tab =
/**
 * An individual tab in a TabList or TabView
 */
(0, _convertUnsafeMethod["default"])(_class = (0, _focusRing["default"])(_class = (_temp = _class2 =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Tab, _Component);

  function Tab(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Tab);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Tab).call(this, props));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleClick", function (e) {
      if (!_this.props.disabled && _this.props.onClick) {
        _this.props.onClick(e);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleKeyPress", function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();

        _this.handleClick(e);
      }
    });
    _this.tabId = (0, _createId["default"])();
    return _this;
  }

  (0, _createClass2["default"])(Tab, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$id = _this$props.id,
          id = _this$props$id === void 0 ? this.tabId : _this$props$id,
          label = _this$props.label,
          children = _this$props.children,
          className = _this$props.className,
          selected = _this$props.selected,
          disabled = _this$props.disabled,
          invalid = _this$props.invalid,
          icon = _this$props.icon,
          renderChildren = _this$props.renderChildren,
          _this$props$tabIndex = _this$props.tabIndex,
          tabIndex = _this$props$tabIndex === void 0 ? 0 : _this$props$tabIndex,
          otherProps = (0, _objectWithoutProperties2["default"])(_this$props, ["id", "label", "children", "className", "selected", "disabled", "invalid", "icon", "renderChildren", "tabIndex"]);
      var iconSize = label || renderChildren && children ? 'XS' : 'S';
      return _react["default"].createElement("div", (0, _extends2["default"])({}, (0, _filterDOMProps["default"])(otherProps), {
        className: (0, _classnames["default"])('spectrum-Tabs-item', {
          'is-selected': selected,
          'is-disabled': disabled,
          'is-invalid': invalid
        }, className),
        id: id,
        role: "tab",
        "aria-selected": selected,
        "aria-invalid": invalid || null,
        "aria-disabled": disabled || null,
        tabIndex: !disabled ? tabIndex : null,
        onClick: !disabled ? this.handleClick : null,
        onKeyPress: !disabled ? this.handleKeyPress : null
      }), (0, _icon.cloneIcon)(icon, {
        size: iconSize,
        className: 'spectrum-Tabs-item-icon'
      }), (label || renderChildren && children) && _react["default"].createElement("span", {
        className: "spectrum-Tabs-itemLabel"
      }, label || renderChildren && children));
    }
  }]);
  return Tab;
}(_react.Component), (0, _defineProperty2["default"])(_class2, "displayName", 'Tab'), (0, _defineProperty2["default"])(_class2, "propTypes", {
  /** Class to add to tab */
  className: _propTypes["default"].string,

  /** Whether the tab should be disabled or not */
  disabled: _propTypes["default"].bool,

  /** Icon to add to tab */
  icon: _propTypes["default"].object,

  /** Whether to disable the invalid icon on the tab */
  invalid: _propTypes["default"].bool,

  /** Tab label */
  label: _propTypes["default"].string,

  /** Whether to render children in the tab */
  renderChildren: _propTypes["default"].bool,

  /** Whether the tab is selected */
  selected: _propTypes["default"].bool,

  /** Index of the tab in the grouping */
  tabIndex: _propTypes["default"].number
}), (0, _defineProperty2["default"])(_class2, "defaultProps", {
  disabled: false,
  invalid: false,
  selected: false,
  tabIndex: 0,
  renderChildren: true
}), _temp)) || _class) || _class;

exports["default"] = Tab;